import { fromJS, OrderedMap} from 'immutable';
import config from '../config/app.json';


const initialState = fromJS({
  "name": "Untitled Project",
  "duration": "13",
  "width": 800,
  "height": 450,
  "scenes": [],
  "audios": {},
  "videos": {}
})

var oldBounds = fromJS([]);

var sceneDurationReset = (stateVal) => {
  var oldDuration = 0, totalDuration = 0;
  for (var i = 0; i < stateVal.getIn(['scenes']).size; i++) {
    stateVal = stateVal.setIn(['scenes', i, 'startTime'], oldDuration);
    oldDuration = stateVal.getIn(['scenes', i, 'duration']) + stateVal.getIn(['scenes', i, 'startTime']);
    totalDuration += stateVal.getIn(['scenes', i, 'duration']);
  }
  stateVal = stateVal.set('duration', totalDuration);
  return stateVal;
}

export var getCorner = (pivotX, pivotY, cornerX, cornerY, angle) => {
  var x, y, distance, diffX, diffY;

  /// get distance from center to point
  diffX = cornerX - pivotX;
  diffY = cornerY - pivotY;
  distance = Math.sqrt(diffX * diffX + diffY * diffY);
  
  /// find angle from pivot to corner
  angle += Math.atan2(diffY, diffX);

  /// get new x and y and round it off to integer
  x = pivotX + distance * Math.cos(angle);
  y = pivotY + distance * Math.sin(angle);
  
  return {x:x, y:y};
}

var getSelectionBoxBounds = (data) => {
  
  var angle = data.angle * Math.PI / 180
  var c1, c2, c3, c4,    /// corners
  bx1, by1, bx2, by2, bounds;
  c1 = getCorner(data.cx, data.cy, data.x, data.y, angle);
  c2 = getCorner(data.cx, data.cy, data.x + data.width, data.y, angle);
  c3 = getCorner(data.cx, data.cy, data.x + data.width, data.y + data.height, angle);
  c4 = getCorner(data.cx, data.cy, data.x, data.y + data.height, angle);
  /// get bounding box
  bx1 = Math.min(c1.x, c2.x, c3.x, c4.x);
  by1 = Math.min(c1.y, c2.y, c3.y, c4.y);
  bx2 = Math.max(c1.x, c2.x, c3.x, c4.x);
  by2 = Math.max(c1.y, c2.y, c3.y, c4.y);

  bounds = {x: parseFloat(bx1.toFixed(2)), y: parseFloat(by1.toFixed(2)), width: parseFloat((bx2 - bx1).toFixed(2)), height: parseFloat((by2 - by1).toFixed(2))};
  
  return bounds;
}

export var getObjectsBounds = (objects, isResize) =>{
  var minX = 0, maxX = 0, minY = 0, maxY = 0;
  var count = 0;
  objects.entrySeq().forEach(([key, item]) => {
    
    let bounds = getSelectionBoxBounds({x:item.get("x"), y: item.get("y"), cx : item.get("x") + item.get("width") / 2, cy :  item.get("y") + item.get("height") / 2, width : item.get("width"), height : item.get("height"), angle : item.get("angle")});

    let x = bounds.x, y = bounds.y, width = bounds.width, height = bounds.height;

    if (count === 0) {
      minX = x; maxX = x + width; minY = y; maxY = y + height;
      count++;
    } else {
      minX = Math.min(minX, x); maxX = Math.max(maxX, x + width); minY = Math.min(minY, y); maxY = Math.max(maxY, y + height);
    }
  });
  
  return {x : minX, y : minY, width : maxX - minX, height : maxY - minY}
}


function animakerStore(state = initialState, action) {
  var selectedScene, currentContainer = (state.getIn(['essentials', 'selectedCamera']) !== "") ? "workspaceCameras" : "workspaceItems", getAllItems, getAllChildren, currentSlide = 0, allChildren, allWorkspaceItems, uniqueId, workspaceItems;
  var duration = 0;
  
  switch (action.type) {
    case "ADD_SCENE_COMPLETE":
    state = state.updateIn(["scenes"], list => list.splice(action.slideIndex, 0, fromJS(action.newslide)));  
    let duration = state.get("duration");
    state = sceneDurationReset(state);
    return state;

    case "DUPLICATE_SCENE_COMPLETE":
      state = state.updateIn(["scenes"], list => list.splice(action.slideIndex, 0, fromJS(action.newslide)));
      state = state.setIn(["scenes", action.slideIndex, "workspaceItems"], state.getIn(["scenes", action.slideIndex, "workspaceItems"]).sortBy(function (value, key){return value.get("index");}).toOrderedMap());
      state = sceneDurationReset(state);
    
    return state;

    case "MOVE_SCENE_COMPLETE":
     
      var sceneDetails=state.getIn(['scenes']).toJS();
      sceneDetails = sceneDetails.slice(0);
      sceneDetails.splice(action.newIndex, 0, sceneDetails.splice(action.oldIndex, 1)[0]);
      let allScenes = fromJS(sceneDetails);
      allScenes.entrySeq().forEach(([sceneNum, sceneVal]) => {
        sortedItems = sceneVal.get("workspaceItems").sortBy(function (value, key) {
          return value.get("index");
        });
        allScenes = allScenes.setIn([sceneNum, "workspaceItems"], sortedItems.toOrderedMap());
      });

      state=state.setIn(['scenes'], allScenes);
      state = sceneDurationReset(state);
    return state;
      

    case "REMOVE_SCENE_COMPLETE":
      let currentSceneStartTime = state.getIn(['scenes',action.slideIndex, "startTime"]);
      let currentSceneEndTime = currentSceneStartTime+state.getIn(['scenes',action.slideIndex, "duration"])
      state = state.updateIn(['scenes'], list => list.splice(action.slideIndex, 1));
      state = sceneDurationReset(state);
      return state;
     
     


    case 'ADD_SCENE_TRANSITION_COMPLETE':
        state = state.setIn(["scenes", action.slideIndex, "transEffect"], action.transitionName)

      state = state.setIn(["scenes", action.slideIndex, "sizes"], fromJS(action.sizes))
      return state;
      case "ADD_SCENE_TRANSITION_COLOR_COMPLETE":
      
          state = state.setIn(["scenes", action.selectedScene, "transColor"], OrderedMap(action.color))
      return state

    case "INITIATE_PROJECT":
      let project = fromJS(action.data.project);
      let sortedProject = project, sortedItems = null;

      if(project.get('height')){
        state = state.set('height', project.get('height'));
      }
      if(project.get('width')){
        state = state.set('width', project.get('width'));
      }
      project.get("scenes").entrySeq().forEach(([sceneNum, sceneVal]) => {
        sortedItems = sceneVal.get("workspaceItems").sortBy(function (value, key) {
          return value.get("index");
        });
        sortedProject = sortedProject.setIn(["scenes", sceneNum, "workspaceItems"], sortedItems.toOrderedMap());
      });
      
      return sortedProject;

    case 'CHANGE_ACTION_COMPLETE':   
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "animdata"], action.itemLabel.animdata);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "height"], action.itemLabel.height);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "width"], action.itemLabel.width);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "src"], action.itemLabel.src);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "pose"], action.itemLabel.pose);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "expFlag"], action.itemLabel.expFlag);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "isRepeated"], action.itemLabel.isRepeated);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "mouthAction"], action.itemLabel.mouthAction);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "expression"], action.itemLabel.expression);
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "colors"], fromJS(action.itemLabel.colors));
    return state;

    case 'CHANGE_EXPRESSION_COMPLETE':   
      state = state.setIn(["scenes", action.selectedIndex, "workspaceItems", action.itemId, "expression"], action.itemLabel);
    return state;


    case 'ADD_OBJECT_COMPLETE':
        
        selectedScene = action.selectedScene;
        var workspaceItems = state.getIn(["scenes", selectedScene, "workspaceItems"]);
        var workspaceChildren = state.getIn(["scenes", selectedScene, "workspaceChildren"]);
        
        for(var i = 0; i < action.workspaceIds.length; i++){
          workspaceItems = workspaceItems.set(action.workspaceIds[i], fromJS(action.workspaceData[i]));
          if(!action.workspaceData[i].deleteAudio && action.workspaceData[i].voiceOverData && action.workspaceData[i].voiceOverData.length){
            for(let v=0; v<action.workspaceData[i].checkAudio.length; v++){
              state = state.updateIn(['audios', action.workspaceData[i].checkAudio[v]], value => value.set('parent', action.workspaceData[i].voiceOverData[v][action.workspaceData[i].checkAudio[v]]));
            }
            
          }else if(action.workspaceData[i].deleteAudio && action.workspaceData[i].deleteAudio.length){
            for(let v=0; v<action.workspaceData[i].deleteAudio.length; v++){
              state = state.updateIn(['audios', action.workspaceData[i].deleteAudio[v]], value => value.delete('parent'));
            }
          }
        }

        for(var i = 0; i < action.workspaceChildrenIds.length; i++){
          workspaceChildren = workspaceChildren.set(action.workspaceChildrenIds[i], fromJS(action.workspaceChildData[i]));
        }
      
       
        state = state.setIn(["scenes", selectedScene, "workspaceItems"], fromJS(workspaceItems.toJS()).sortBy(function (value, key){return value.get("index");}).toOrderedMap());
        state = state.setIn(["scenes", selectedScene, "workspaceChildren"], workspaceChildren);
        
    return state;

   

  case "UPDATE_BGCOLOR_COMPLETE":
     state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "bgColor", action.Cls], action.color);
    return state;

    case "UPDATE_BGGRADIENT_COMPLETE":
     state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "gradient", action.gradientIndex, action.gradientSecIndex], action.color);
    return state;

    case "CHANGE_ANIMATION_TYPE_COMPLETE":
    state = state.setIn(["scenes", action.selectedScene, "workspaceItems", action.itemId, "isAnimated"], action.value);
    return state;

    case "MOVE_UPDATE_COMPLETE":
     
        var workspaceItems = fromJS(action.workspaceItems);
        var workspaceChildren = fromJS(action.workspaceChildren);
       
        if(workspaceItems.size > 0){
          var allWorkspaceItems = state.getIn(["scenes", action.selectedScene, action.currentContainer]);
          workspaceItems.entrySeq().forEach(([key, item]) => {
            state = state.setIn(["scenes", action.selectedScene, action.currentContainer, key], allWorkspaceItems.get(key).merge(item));
          });
        }

        if(workspaceChildren.size > 0){
          var allWorkspaceChildren = state.getIn(["scenes", action.selectedScene, "workspaceChildren"]);
          workspaceChildren.entrySeq().forEach(([key, item]) => {
            state = state.setIn(["scenes", action.selectedScene, "workspaceChildren", key], allWorkspaceChildren.get(key).merge(item));
          });
        }
      
    return state;


    case "RESIZE_UPDATE":
        if(action.data.isShapeOnly){
          selectedScene = action.data.selectedScene;  
          let item = action.data.items.first();
          let map_to_update = fromJS({ x: item.get('x'), y: item.get('y'), width: item.get('width'), height: item.get('height')});
          if(item.get("pathData") !== undefined)
            map_to_update.set("pathData", item.get("pathData"));

          state = state.setIn(["scenes", selectedScene, "workspaceItems", action.data.selectedItems.get(0)], state.getIn(["scenes", selectedScene, "workspaceItems", action.data.selectedItems.get(0)]).merge(map_to_update));
        }
    return state;
    case "CHANGE_TEXT_COMPLETE":
     
      if(action.selfUpdate === true){
        state = state.setIn(["scenes", action.selectedScene, action.currentContainer, action.itemId], fromJS(action.objectData));
      }
    return state;


    case "UPDATE_TEXT_COMPLETE":
    
      if(action.selfUpdate === true){
        if(!action.isGrouped){
          var selectedText = state.getIn(["scenes", action.selectedScene, action.container, action.selectedId, "textData"]);
          if(selectedText !== undefined){
          
            selectedText = selectedText.setIn(["formats", "containerStyle"], selectedText.getIn(["formats", "containerStyle"]).merge( fromJS(action.formats.containerStyle) ));
            selectedText = selectedText.setIn(["formats", "others"], selectedText.getIn(["formats", "others"]).merge(fromJS(action.formats.others)));
            
            selectedText = selectedText.setIn(["formats", "bullet"], selectedText.getIn(["formats", "bullet"]).merge(fromJS(action.formats.bullet)));
          
            state = state.setIn(["scenes", action.selectedScene, action.container, action.selectedId, "textData"], selectedText);
          }
        }else{
          action.childIds.entrySeq().forEach(([key, id]) => {
            
          })
        }
      }
      
    return state;


      case "UPDATE_GROUP_OBJECTS_COMPLETE":
       
        if(action.selfUpdate === true){
          selectedScene = action.selectedScene;
          
          for(var key in action.workspaceChildren){
            if(action.workspaceChildren.hasOwnProperty(key))
              state = state.setIn(["scenes", action.selectedScene, "workspaceChildren", key], state.getIn(["scenes", action.selectedScene, "workspaceChildren", key]).merge(fromJS(action.workspaceChildren[key])));
          }

          for(var key in action.workspaceItems){
            if(action.workspaceItems.hasOwnProperty(key))
              state = state.setIn(["scenes", action.selectedScene, "workspaceItems", key], state.getIn(["scenes", action.selectedScene, "workspaceItems", key]).merge(fromJS(action.workspaceItems[key])));
          }
        }
        return state;
      break;


      case "UPDATE_GROUP_TEXT_COMPLETE":
        if(action.selfUpdate === true){
          selectedScene = action.selectedScene;
        
          for(var key in action.workspaceChildren){
            if(action.workspaceChildren.hasOwnProperty(key))
              state = state.setIn(["scenes", action.selectedScene, "workspaceChildren", key], state.getIn(["scenes", action.selectedScene, "workspaceChildren", key]).merge(fromJS(action.workspaceChildren[key])));
          }

          for(var key in action.workspaceItems){
            if(action.workspaceItems.hasOwnProperty(key))
              state = state.setIn(["scenes", action.selectedScene, "workspaceItems", key], state.getIn(["scenes", action.selectedScene, "workspaceItems", key]).merge(fromJS(action.workspaceItems[key])));
          }
        }
        return state;
      break;


      case "FLIP_ITEM_COMPLETE":
        state = state.setIn(["scenes", action.selectedScene, "workspaceItems", action.itemId, "flipPosition"], action.flipPosition);
      return state;



    case 'DELETE_ITEM_COMPLETE':
     
        var selectedItems = action.workspaceIds;
        selectedScene = action.selectedScene;
        
        getAllItems = state.getIn(["scenes", selectedScene, "workspaceItems"]);

        getAllChildren = state.getIn(["scenes", selectedScene, "workspaceChildren"]);

        for (var i = 0; i < selectedItems.length; i++) {
          if (state.getIn(["scenes", selectedScene, "workspaceItems", selectedItems[i], "type"]) === "GROUP") {
            var selectedChildren = state.getIn(["scenes", selectedScene, "workspaceItems", selectedItems[i], "groupChildren"]).toJS();
            getAllChildren = selectedChildren.reduce((map, key) => map.delete(key), getAllChildren);
          }
        }
        getAllItems = selectedItems.reduce((map, key) => map.delete(key), getAllItems);
       
        if(getAllItems.size > 0){
          i = 0;
          getAllItems.entrySeq().forEach(([key, value]) => {
            getAllItems = getAllItems.setIn([key, "index"], i);
            getAllItems = getAllItems.setIn([key, "animIndex"], i);
            i++;
          });
        }
        
        state = state.setIn(["scenes", selectedScene, "workspaceItems"], getAllItems);
        state = state.setIn(["scenes", selectedScene, "workspaceChildren"], getAllChildren);
       
      
      return state;

   

    case "CHANGE_SCENE_DURATION_COMPLETE":
      let newDuration = parseFloat(action.objectData);
      let videoEnd = parseFloat(action.videoEndTime);
      let bgType = state.getIn(['scenes', action.selectedScene, 'workspaceBG', "type"])
      if (bgType === "STOCKVID" || bgType === "UPVIDEO" || bgType === "VIDEO") {
        if (state.getIn(['scenes', action.selectedScene, 'workspaceBG', "videoDuration"]) - state.getIn(['scenes', action.selectedScene, 'workspaceBG', "videoStart"]) + state.getIn(['scenes', action.selectedScene, "startTime"]) <= action.objectData){
          newDuration = state.getIn(['scenes', action.selectedScene, 'workspaceBG', "videoDuration"]) - state.getIn(['scenes', action.selectedScene, 'workspaceBG', "videoStart"]);
        }
      }
      state = state.setIn(['scenes', action.selectedScene, 'duration'], newDuration);
      state = state.setIn(['scenes', action.selectedScene, 'playHeadValue'], parseFloat(action.playHead));
      state = state.setIn(['scenes', action.selectedScene, 'workspaceBG', 'videoEnd'], videoEnd);

      state = sceneDurationReset(state);
      return state;

      case "UPDATE_TIMELINE_DRAG_COMPLETE":

      selectedScene = action.selectedScene;
      let itr = 0;
      if (action.itemData === "audios") {
        for (itr = 0; itr < action.actionData.length; itr++)
          state = state.setIn([action.itemData, action.idVal, action.actionData[itr].name], action.actionData[itr].value);
      }
      else if (action.itemData === "workspaceItems") {
       
        for (itr = 0; itr < action.actionData.length; itr++) {
          if (action.actionData[itr].name !== "enterEffectName")
            action.actionData[itr].value = parseFloat((parseFloat(action.actionData[itr].value)).toFixed(1));
          if (action.actionData[itr].name === 'playHead')
            state = state.setIn(['scenes', selectedScene, 'playHeadValue'], action.actionData[itr].value);         
          else if (action.actionData[itr].name === 'duration') {
            state = state.setIn(['scenes', selectedScene, 'duration'], action.actionData[itr].value);
            state = sceneDurationReset(state);
            let playHead = state.getIn(['scenes', selectedScene, 'playHeadValue']);
            if (playHead > action.actionData[itr].value)
              state = state.setIn(['scenes', selectedScene, 'playHeadValue'], action.actionData[itr].value);
            }
          else if (action.actionData[itr].name === 'endTime')
            state = state.setIn(['scenes', selectedScene, 'workspaceCameras', action.actionData[itr].id, 'endTime'], action.actionData[itr].value);
          else if (action.actionData[itr].name === 'camDelete')
            state = state.updateIn(['scenes', selectedScene, 'workspaceCameras'], value => value.delete(action.actionData[itr].id));
          else if (action.actionData[itr].name === 'voiceStart' || action.actionData[itr].name === 'voiceEnd' || action.actionData[itr].name === 'playStart' || action.actionData[itr].name === 'playEnd')
            state = state.setIn(["scenes", selectedScene, "workspaceItems", action.actionData[itr].id, "voiceOver", "audio", action.actionData[itr].name], action.actionData[itr].value);
            else if (action.actionData[itr].name === 'bgEnd')
            state = state.setIn(['scenes', selectedScene, 'workspaceBG', 'exitEnd'], action.actionData[itr].value);
          else if (action.actionData[itr].name === 'bgStart')
            state = state.setIn(['scenes', selectedScene, 'workspaceBG', 'enterStart'], action.actionData[itr].value);
          else if (action.actionData[itr].name === 'videoEnd')
          {
            let videoEnd = action.actionData[itr].value;
            if(videoEnd > state.getIn(['scenes', selectedScene, 'workspaceBG', 'videoDuration']))
              videoEnd = state.getIn(['scenes', selectedScene, 'workspaceBG', 'videoDuration'])
            state = state.setIn(['scenes', selectedScene, 'workspaceBG', 'videoEnd'], videoEnd);
          }
          else if (action.actionData[itr].name === 'videoStart')
            state = state.setIn(['scenes', selectedScene, 'workspaceBG', 'videoStart'], action.actionData[itr].value);
          else if (action.actionData[itr].name !== 'audioplayhead'){
            state = state.setIn(['scenes', selectedScene, action.itemData, action.actionData[itr].id, action.actionData[itr].name], action.actionData[itr].value);
          }
        }

      }
      else if(action.itemData === "workspaceBG"){
        for (itr = 0; itr < action.actionData.length; itr++) {
            if(action.actionData[itr].name === 'bgStart')
              state = state.setIn(["scenes", selectedScene, "workspaceBG", "enterStart"], action.actionData[itr].value);
            else if(action.actionData[itr].name === 'bgEnd')
              state = state.setIn(["scenes", selectedScene, "workspaceBG", "exitEnd"], action.actionData[itr].value);
            else if(action.actionData[itr].name === 'bgEnter')
              state = state.setIn(["scenes", selectedScene, "workspaceBG", "enterEnd"], action.actionData[itr].value);
            else if(action.actionData[itr].name === 'bgExit')
              state = state.setIn(["scenes", selectedScene, "workspaceBG", "exitStart"], action.actionData[itr].value);
            else
              state = state.setIn(["scenes", selectedScene, "workspaceBG", action.actionData[itr].name], action.actionData[itr].value);
          }
      }
      else {
        for (itr = 0; itr < action.actionData.length; itr++)
          state = state.setIn(['scenes', selectedScene, action.itemData, action.idVal, action.actionData[itr].name], action.actionData[itr].value);
      }
     
      if(Object.keys(action.childToUpdate).length > 0){
        for(var key in action.childToUpdate){
          state = state.setIn(['scenes', selectedScene, 'workspaceChildren', key], state.getIn(['scenes', selectedScene, 'workspaceChildren', key]).merge(fromJS(action.childToUpdate[key])));
        }
      }
      return state;

    case "APPLY_ENTER_EFFECT_COMPLETE":
      if(action.isUndo !== true){
      if(action.effectData.isapplyToallSlides===true){
        state.getIn(['scenes']).entrySeq().forEach(([sceneNum, value]) => {
          state.getIn(['scenes',sceneNum,'workspaceItems']).entrySeq().forEach(([key, value]) => {
           
            state=state.setIn(['scenes',sceneNum,'workspaceItems',key,'enterEffectName'],action.effectData.effectName);
 
         });
       });

      }
      else{
      state.getIn(['scenes',action.selectedScene,'workspaceItems']).entrySeq().forEach(([key, value]) => {
           
           state=state.setIn(['scenes',action.selectedScene,'workspaceItems',key,'enterEffectName'],action.effectData.effectName);

        });
      }
    }
    else if(action.isUndo){
      for (const [scene, workspaceItem] of Object.entries(action.sceneEffectData)) {
        for ( const[key,value] of Object.entries(workspaceItem)){
          state = state.setIn(['scenes',scene,'workspaceItems',key,'enterEffectName'],value)
        }
      }
    }

    return state;
 
    case 'SET_Z_INDEX_COMPLETE':
      selectedScene = action.selectedScene;
      workspaceItems = state.getIn(["scenes", selectedScene, "workspaceItems"]);
      var workspaceIndex = fromJS(action.indexChangeIds)
      workspaceIndex.entrySeq().forEach(([key, value]) =>
      {
        state = state.setIn(["scenes", selectedScene, "workspaceItems", key, "index"], value.get("index"));
      });
      workspaceItems = state.getIn(["scenes", selectedScene, "workspaceItems"]).sortBy(function (value, key)
      {
        return value.get("index");
      });
      state = state.setIn(["scenes", selectedScene, "workspaceItems"], workspaceItems);
      return state;


    case 'UPDATE_VIDEO_DATA_COMPLETE':
      
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG"], fromJS(action.workspaceBg));

      if(state.getIn(["scenes", action.selectedScene, "isContinuous"])){
        var workspaceBG = action.workspaceBG;
        if(workspaceBG.exitEnd === state.getIn(["scenes", action.selectedScene, "duration"])){
          workspaceBG.enterStart = 0;
          var videoStart = workspaceBG.videoEnd;
          var videoEnd = videoStart + 10;
          if(videoEnd > workspaceBG.duration)
            videoEnd = workspaceBG.duration;
          
          workspaceBG.videoStart = videoStart;
          workspaceBG.videoEnd = videoEnd;
          workspaceBG.exitEnd = videoEnd - videoStart;
          state = state.setIn(["scenes", action.selectedScene + 1, "workspaceBG"], fromJS(workspaceBG));
        }
      }

      return state;

    case 'DELETE_BG_COMPLETE':
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "src"], "");
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "thumbnail"], "");
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "type"], "");
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "subType"], "");
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "stockId"], "");
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "flipPosition"], 0);
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "angle"], 0);
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "bgFilter"], "");
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "videoStart"], 0);
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "isBlob"], false);
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "videoEnd"], state.getIn(["scenes", action.selectedScene, "duration"]));
      return state;

    case "DROP_BG_COMPLETE":

    state = state.setIn(["scenes", action.selectedScene, "workspaceBG"], fromJS(action.workspaceBG));
      if(action.deleteId !== ""){
        let allWorkspaceItems = state.getIn(["scenes", action.selectedScene, "workspaceItems"]);
        allWorkspaceItems     = allWorkspaceItems.delete(action.deleteId);
        state = state.setIn(["scenes", action.selectedScene, "workspaceItems"], allWorkspaceItems);
      }
      else if(action.workspaceBG.type === "STOCKVID" || action.workspaceBG.type === "UPVIDEO" || action.workspaceBG.type === 'VIDEO')
      {
        state = state.setIn(["scenes", action.selectedScene, "duration"], action.workspaceBG.videoDuration);
        state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "videoEnd"], action.workspaceBG.videoDuration);
        state = sceneDurationReset(state);

        for (itr = 0; itr < action.deleteData.length; itr++) {
          if (action.deleteData[itr].name !== "enterEffectName")
            action.deleteData[itr].value = parseFloat((parseFloat(action.deleteData[itr].value)).toFixed(1));
          if (action.deleteData[itr].name === 'endTime')
            state = state.setIn(['scenes', action.selectedScene, 'workspaceCameras', action.deleteData[itr].id, 'endTime'], action.deleteData[itr].value);
          else if (action.deleteData[itr].name === 'camDelete')
            state = state.updateIn(['scenes', action.selectedScene, 'workspaceCameras'], value => value.delete(action.deleteData[itr].id));
          else
          {
            state = state.setIn(['scenes', action.selectedScene, "workspaceItems", action.deleteData[itr].id, action.deleteData[itr].name], action.deleteData[itr].value);

          }
        }
      }

     
    return state;

    case "CROP_IMAGE_COMPLETE":
      state = state.setIn(["scenes", action.selectedScene, "workspaceItems", action.itemId], fromJS(action.objectData));
    return state;


    case "CROP_BG_COMPLETE":
      selectedScene = action.selectedScene;
      
      if(!action.isVideo)
      {
        state = state.setIn(["scenes", selectedScene, "workspaceBG"], fromJS(action.objectData));        
      }
      else 
        state = state.setIn(["videos", action.videoId, "bgScales"], fromJS(action.data.bgScales));
      
    return state;



    case "PASTE_ITEMS_COMPLETE":
     
      for (var i = 0; i < action.workspaceIds.length; i++)
      {
        state = state.setIn(['scenes', action.selectedScene, 'workspaceItems', action.workspaceIds[i]], fromJS(action.workspaceData[i]));
      }
      for (var m = 0; m < action.workspaceChildrenIds.length; m++)
      {
        state = state.setIn(['scenes', action.selectedScene, 'workspaceChildren', action.workspaceChildrenIds[m]], fromJS(action.workspaceChildData[m]));
       
      }

      state = state.setIn(["scenes", action.selectedScene, "workspaceItems"], state.getIn(["scenes", action.selectedScene, "workspaceItems"]).sortBy(function (value, key) {return value.get("index");}).toOrderedMap());
      
    return state;

    case "PASTE_SCENES_COMPLETE":
     
      var copiedScenes = action.scenes;
      var selectedScene = action.selectedScene + 1;
      var allScenes = state.get("scenes").toJS();
      copiedScenes.unshift(selectedScene, 0);
      Array.prototype.splice.apply(allScenes, copiedScenes);
      allScenes = fromJS(allScenes);

      allScenes.entrySeq().forEach(([sceneNum, sceneVal]) => {
        sortedItems = sceneVal.get("workspaceItems").sortBy(function (value, key) {
          return value.get("index");
        });
        allScenes = allScenes.setIn([sceneNum, "workspaceItems"], sortedItems.toOrderedMap());
      });

      state = state.set("scenes", allScenes);
      state = sceneDurationReset(state);
     
    return state;
      

  case "GROUP_OBJECTS_COMPLETE":

      selectedScene = action.selectedScene;
      if(action.removeIds.length > 0){

        getAllItems = fromJS(action.removeIds).reduce((map, key) => map.delete(key), state.getIn(["scenes", selectedScene, "workspaceItems"]));
        state = state.setIn(["scenes", selectedScene, "workspaceItems"], getAllItems)
        state = state.setIn(["scenes", selectedScene, "workspaceItems"], state.getIn(["scenes", selectedScene, "workspaceItems"]).merge(fromJS(action.workspaceItems)))
                     .setIn(["scenes", selectedScene, "workspaceChildren"], state.getIn(["scenes", selectedScene, "workspaceChildren"]).merge(fromJS(action.workspaceChildren)));
        const itemsOrder =action.workspaceItemsOrder;
          for(let key in itemsOrder){
              state = state.setIn(['scenes',selectedScene,'workspaceItems',key,'animIndex'],itemsOrder[key]);

          }

      }
     
    return state;


    case "UNGROUP_OBJECTS_COMPLETE":
      selectedScene = action.selectedScene;
      if (action.removeIds.length > 0)
      {
        let childIds = state.getIn(["scenes", selectedScene, "workspaceItems", action.removeIds[0], "groupChildren"]);
        
        getAllItems = fromJS(action.removeIds).reduce((map, key) => map.delete(key), state.getIn(["scenes", selectedScene, "workspaceItems"]));
        state = state.setIn(["scenes", selectedScene, "workspaceItems"], getAllItems);
        let unGroupedItems = fromJS(action.workspaceChildren);
        state = state.setIn(["scenes", selectedScene, "playHeadValue"], unGroupedItems.maxBy(x => x.get("enterStart")).get("enterStart"));
          allWorkspaceItems     = state.getIn(["scenes", selectedScene, "workspaceItems"]).merge(unGroupedItems);

          allChildren = childIds.toArray().reduce((map, key) => map.delete(key), state.getIn(["scenes", selectedScene, "workspaceChildren"]));     
          allWorkspaceItems = allWorkspaceItems.sortBy(function (value, key) {
            return value.get("index");
          });
          state = state.setIn(["scenes", selectedScene, "workspaceItems"], allWorkspaceItems).setIn(["scenes", selectedScene, "workspaceChildren"], allChildren);
          const itemsOrder =action.workspaceItemsOrder;
          for(let key in itemsOrder){
              state = state.setIn(['scenes',selectedScene,'workspaceItems',key,'animIndex'],itemsOrder[key]);

          }
          
      }
      return state;

      case "BG_COLOR_SELECTION_COMPLETE":
      state =  state.setIn(["scenes", action.selectedScene, "workspaceBG", "color"], fromJS(action.objectData));
      return state;


      case 'UPDATE_SVGCOLOR_COMPLETE':
        
        state = state.setIn(["scenes", action.selectedScene, action.container, action.itemId, "colors", action.itemCls], action.colorData);  
       
      return state;

      case 'UPDATE_SVGTHEME_COMPLETE':
      if(!action.isBG)
        state = state.setIn(["scenes", action.selectedScene, action.container, action.itemId, "colors"], fromJS(action.colorData));
      else
        state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "bgColor"], fromJS(action.colorData));
      return state;
      

    case 'APPLY_FILTER_COMPLETE':
     
      if(action.objectId !== "BG"){
        state = state.setIn(["scenes", action.selectedScene, "workspaceItems", action.objectId, "filter"], action.objectData);
      }
      else{
        state = state.setIn(["scenes", action.selectedScene, "workspaceBG" ,"bgFilter"], action.objectData);
      }
      return state;
    

    case 'BG_GRADIENT_COLORS_COMPLETE':
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "isRadial"], action.radialStatus);
      state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "radius"], action.radius);

      if (!action.radialStatus)
      {
        state = state.setIn(["scenes", action.selectedScene, "workspaceBG", "direction"], action.direction);
      }
      return state;



    case "RESIZE_PROJECT":
      var projectWidth = 800, projectHeight = 450, scale, modifyWidth, modifyHeight, modifyX, modifyY, scale, setCenterX = 0, setCenterY = 0;
      var oldWidth = state.get('width');
      var oldHeight = state.get('height');

      var oldType = (oldWidth === 800 && oldHeight === 450)?"horizontal":(oldWidth === 450 && oldHeight === 800)?"vertical":(oldWidth === 450 && oldHeight === 450)?"square":"custom";

      var newType = action.data.type;

      if(newType === "horizontal"){
      }
      else if(newType === "vertical"){
        projectWidth = 450; projectHeight = 800;
      }else if(newType === "square"){
        projectWidth = 450; projectHeight = 450;
      }else{
        projectWidth = action.data.width; projectHeight = action.data.height;
      }
      
      var oldRatio = oldWidth / oldHeight;
      var newRatio = projectWidth / projectHeight;

      var widthScale = projectWidth / oldWidth;
      var heightScale = projectHeight / oldHeight;
      var positionScale = widthScale;
      

      state.get("scenes").entrySeq().forEach(([sceneNum, sceneVal]) => {
        var xScale = false, yScale = false;
        
        var sceneBounds = getObjectsBounds(state.getIn(["scenes", sceneNum, "workspaceItems"]), true);
        var isReverted = (Math.round(oldBounds.getIn([sceneNum, "width"])) === Math.round(sceneBounds.width * widthScale) && Math.round(oldBounds.getIn([sceneNum, "height"])) === Math.round(sceneBounds.height * widthScale));
        
        if(oldType === "vertical"){
          scale = widthScale;
        
          if(((sceneBounds.width >= oldWidth && sceneBounds.width * scale >= projectWidth) || (sceneBounds.height <= oldHeight && sceneBounds.height * scale >= projectHeight)) && !isReverted){
            
            scale = heightScale;
            if(sceneBounds.width * scale <= projectWidth || newType === "square"){
              
              setCenterX = (projectWidth / 2) - ((sceneBounds.width * scale) / 2);
              setCenterX = (setCenterX > (sceneBounds.x * scale)) ? (setCenterX - (sceneBounds.x * scale)) : -((sceneBounds.x * scale) - setCenterX);
            }
          }
          
          setCenterY = (projectHeight / 2) - ((sceneBounds.height * scale) / 2);
          setCenterY = (setCenterY > (sceneBounds.y * scale)) ? (setCenterY - (sceneBounds.y * scale)) : -((sceneBounds.y * scale) - setCenterY);
        }
        else if(oldType === "horizontal"){
          scale = widthScale;

          
          setCenterY = (projectHeight / 2) - ((sceneBounds.height * scale) / 2);
          setCenterY = (setCenterY > (sceneBounds.y * scale)) ? (setCenterY - (sceneBounds.y * scale)) : -((sceneBounds.y * scale) - setCenterY);
        }
        else if(oldType === "square"){
          if(newType === "horizontal"){
            scale = widthScale;
            setCenterY = (projectHeight / 2) - ((sceneBounds.height * scale) / 2);
            setCenterY = (setCenterY > (sceneBounds.y * scale)) ? (setCenterY - (sceneBounds.y * scale)) : -((sceneBounds.y * scale) - setCenterY);
          }
          else if(newType === "vertical"){
            scale = widthScale;
            if(isReverted){
              scale = widthScale;
            }
            setCenterY = (projectHeight / 2) - ((sceneBounds.height * scale) / 2);
            setCenterY = (setCenterY > (sceneBounds.y * scale)) ? (setCenterY - (sceneBounds.y * scale)) : -((sceneBounds.y * scale) - setCenterY);
          }
        }

        var newBoundWidth = sceneBounds.width * scale;
        var newBoundHeight = sceneBounds.height * scale;

        if(xScale){
          if (projectWidth > newBoundWidth) {
            setCenterX = (projectWidth / 2) - (newBoundWidth / 2);
            setCenterX = (setCenterX > (sceneBounds.x * scale)) ? (setCenterX - (sceneBounds.x * scale)) : -((sceneBounds.x * scale) - setCenterX);
          } else {
            setCenterX = -(sceneBounds.x * scale);
          }
        }

        if(yScale){
          if(projectHeight > newBoundHeight){
            setCenterY = (projectHeight / 2) - (newBoundHeight / 2);
            setCenterY = (setCenterY > (sceneBounds.y * scale)) ? (setCenterY - (sceneBounds.y * scale)) : -((sceneBounds.y * scale) - setCenterY);
          
          }else{
            
            setCenterY = -(sceneBounds.y * scale);
          }
        }

      
        getAllItems = state.getIn(["scenes", sceneNum, "workspaceItems"]);
        getAllChildren = sceneVal.get("workspaceChildren");
        var getAllCameras = sceneVal.get("workspaceCameras");
       

        if(sceneVal.get("workspaceBG") !== undefined){

          if(oldType === "horizontal"){
            if(newType === "vertical"){
              if((sceneVal.getIn(["workspaceBG", "height"]) * oldHeight) <= projectHeight)
              {
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], 1);
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], 0);
                let bgWidthScale = ((projectHeight / (sceneVal.getIn(["workspaceBG", "height"]) * oldHeight)) * (sceneVal.getIn(["workspaceBG", "width"]) * oldWidth)) / projectWidth;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], bgWidthScale);
                let dW = projectWidth - (projectWidth * bgWidthScale);
                if(isNaN(dW))
                  dW = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], (dW / 2) / projectWidth);
              }else{
                let bgHeightScale = (sceneVal.getIn(["workspaceBG", "height"]) * oldHeight) / projectHeight;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], bgHeightScale);
                let dH = projectHeight - (projectHeight * bgHeightScale);
                if(isNaN(dH))
                  dH = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], (dH / 2) / projectHeight);

                let bgWidthScale = (sceneVal.getIn(["workspaceBG", "width"]) * oldWidth) / projectWidth;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], bgWidthScale);
                let dW = projectWidth - (projectWidth * bgWidthScale);
                if(isNaN(dW))
                  dW = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], (dW / 2) / projectWidth);
              }
            }else if(newType === "square"){
            
              let bgWidthScale = state.getIn(["scenes", sceneNum, "workspaceBG", "width"]) * (oldWidth / projectWidth);
              
              state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], bgWidthScale);
              let dW = projectWidth - (projectWidth * bgWidthScale);
              if(isNaN(dW))
                dW = 0
              state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], (dW / 2) / projectWidth);
            }
          }
          else if(oldType === "vertical"){
            if(newType === "horizontal"){
              if((sceneVal.getIn(["workspaceBG", "width"]) * oldWidth) <= projectWidth)
              {
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], 1);
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], 0);

                let bgHeightScale = (sceneVal.getIn(["workspaceBG", "width"]) * oldWidth) / projectWidth;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], bgHeightScale);
                let dH = projectHeight - (projectHeight * bgHeightScale);
                if(isNaN(dH))
                  dH = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], (dH / 2) / projectHeight);
              }
              else{
                
                let bgWidthScale = (sceneVal.getIn(["workspaceBG", "width"]) * oldWidth) / projectWidth;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], bgWidthScale);
                let dW = projectWidth - (projectWidth * bgWidthScale);
                if(isNaN(dW))
                  dW = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], (dW / 2) / projectWidth);

                let bgHeightScale = (sceneVal.getIn(["workspaceBG", "height"]) * oldHeight) / projectHeight;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], bgHeightScale);
                let dH = projectHeight - (projectHeight * bgHeightScale);
                if(isNaN(dH))
                  dH = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], (dH / 2) / projectHeight);

              }

            }else if(newType === "square"){
              let bgHeightScale = state.getIn(["scenes", sceneNum, "workspaceBG", "height"]) * (oldHeight / projectHeight);
              
              state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], bgHeightScale);
              let dH = projectHeight - (projectHeight * bgHeightScale);
              if(isNaN(dH))
                dH = 0
              state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], (dH / 2) / projectHeight);
            }
          }
          else if(oldType === "square"){
            if(newType === "horizontal"){
              if((sceneVal.getIn(["workspaceBG", "width"]) * oldWidth) <= projectWidth)
              {
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], 1);
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], 0);

                let bgHeightScale = (sceneVal.getIn(["workspaceBG", "width"]) * oldWidth) / projectWidth;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], bgHeightScale);
                let dH = projectHeight - (projectHeight * bgHeightScale);
                if(isNaN(dH))
                  dH = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], (dH / 2) / projectHeight);
              }else{
                let bgWidthScale = (sceneVal.getIn(["workspaceBG", "width"]) * oldWidth) / projectWidth;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], bgWidthScale);
                let dW = projectWidth - (projectWidth * bgWidthScale);
                if(isNaN(dW))
                  dW = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], (dW / 2) / projectWidth);
              }
            }else if(newType === "vertical"){
              if((sceneVal.getIn(["workspaceBG", "height"]) * oldHeight) <= projectHeight)
              {
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], 1);
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], 0);
                let bgWidthScale = ((projectHeight / (sceneVal.getIn(["workspaceBG", "height"]) * oldHeight)) * (sceneVal.getIn(["workspaceBG", "width"]) * oldWidth)) / projectWidth;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "width"], bgWidthScale);
                let dW = projectWidth - (projectWidth * bgWidthScale);
                if(isNaN(dW))
                  dW = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "x"], (dW / 2) / projectWidth);
              }else{
                let bgHeightScale = (sceneVal.getIn(["workspaceBG", "height"]) * oldHeight) / projectHeight;
               
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "height"], bgHeightScale);
                let dH = projectHeight - (projectHeight * bgHeightScale);
                if(isNaN(dH))
                  dH = 0
                state = state.setIn(["scenes", sceneNum, "workspaceBG", "y"], (dH / 2) / projectHeight);
              }
              
            }
          }
        }

        /*************** Set ratio ****************/
        state.getIn(["scenes", sceneNum, "workspaceItems"]).entrySeq().forEach(([key, value]) => {
            getAllItems = getAllItems
              .setIn([key, "x"], (value.get("x") * scale) + setCenterX)
              .setIn([key, "y"], (value.get("y") * scale) + setCenterY)
              .setIn([key, "width"], value.get("width") * scale)
              .setIn([key, "height"], value.get("height") * scale);

            if(value.get("type") === "TEXT" || value.get("subType") === "CALLOUT") {
              let fontSize = getAllItems.getIn([key, "textData", "formats", "containerStyle", "fontSize"]);
              if (fontSize !== undefined) {
                getAllItems = getAllItems.setIn([key, "textData", "formats", "containerStyle", "fontSize"], (parseFloat(fontSize, 10) * scale).toFixed(2) + "px")
              }
            }else if(value.get("type") === "GROUP"){
              value.get("groupChildren").entrySeq().forEach(([cKey, cValue]) => {
                
                getAllChildren = getAllChildren
                  .setIn([cValue, "width"], getAllChildren.getIn([cValue, "width"]) * scale)
                  .setIn([cValue, "height"], getAllChildren.getIn([cValue, "height"]) * scale)
                  .setIn([cValue, "x"], (getAllChildren.getIn([cValue, "x"]) * scale) + setCenterX)
                  .setIn([cValue, "y"], (getAllChildren.getIn([cValue, "y"]) * scale) + setCenterY);
                
                if(getAllChildren.getIn([cValue, "type"]) === "TEXT" || getAllChildren.getIn([cValue, "subType"]) === "CALLOUT"){
                  let fontSize = getAllChildren.getIn([cValue, "textData", "formats", "containerStyle", "fontSize"]);
                  if (fontSize !== undefined) {
                    getAllChildren = getAllChildren.setIn([cValue, "textData", "formats", "containerStyle", "fontSize"], (parseFloat(fontSize, 10) * scale).toFixed(2) + "px");
                  }
                }
              })
            }

          
        });

        if (getAllCameras !== undefined && getAllCameras.size > 0) {
          state.getIn(["scenes", sceneNum, "workspaceCameras"]).entrySeq().forEach(([key, value]) => {
              getAllCameras = getAllCameras
              .setIn([key, "width"], value.get("width") * scale)
              .setIn([key, "height"], value.get("height") * scale)
              .setIn([key, "x"], (value.get("x") * scale) + setCenterX)
              .setIn([key, "y"], (value.get("y") * scale) + setCenterY);
          });
          state = state.setIn(["scenes", sceneNum, "workspaceCameras"], getAllCameras);
        }

        state = state.setIn(["scenes", sceneNum, "workspaceItems"], getAllItems);
        state = state.setIn(["scenes", sceneNum, "workspaceChildren"], getAllChildren);

        oldBounds = oldBounds.set(sceneNum, fromJS(sceneBounds));
      });

      state = state.set("width", projectWidth).set("height", projectHeight);
      
    return state;

    case "UPDATE_OBJECT_COMPLETE":
        state = state.setIn(["scenes", action.selectedScene, action.container, action.selectedItem], state.getIn(["scenes", action.selectedScene, action.container,  action.selectedItem]).merge(fromJS(action.toUpdate)));
    return state;

    case "UPDATE_OBJECT_BY_ID":
      state = state.setIn(["scenes", action.data.selectedScene, action.data.container, action.data.id], state.getIn(["scenes", action.data.selectedScene, action.data.container, action.data.id]).merge(fromJS(action.data.toUpdate)));
      return state;
      

    case "ADD_PREBUILT_COMPLETE":
    
        var prebuiltData = fromJS(action.prebuiltData);
        if(action.addAll !== true){
          if(action.replace !== true)
            state = state.updateIn(["scenes"], list => list.splice(action.selectedScene + 1, 0, prebuiltData));
          else 
            state = state.setIn(["scenes", action.selectedScene], prebuiltData);
        
          state = state.setIn(["scenes", action.selectedScene, "workspaceItems"], state.getIn(["scenes", action.selectedScene, "workspaceItems"]).sortBy(function (value, key) {return value.get("index");}).toOrderedMap());
        }else{
          if(action.replace !== true)
            state = state.set("scenes", prebuiltData.getIn(["project", "scenes"]));
          else
            state = prebuiltData.get("project");

            state.get("scenes").entrySeq().forEach(([sceneNum, sceneVal]) => {
              sortedItems = sceneVal.get("workspaceItems").sortBy(function (value, key) {
                return value.get("index");
              });
              state = state.setIn(["scenes", sceneNum, "workspaceItems"], sortedItems.toOrderedMap());
            });
        }
       
        state = sceneDurationReset(state);
    return state;


    case 'ORGANISE_SCENES':
        if(state.getIn(['scenes']).size > 0){
          let pushValues = fromJS([]);
          action.data.map((each,index)=>{
            pushValues = pushValues.set(index, state.getIn(['scenes', each]));
          })
          state = state.setIn(['scenes'], pushValues);
        }
    return state;
    
    break;

    case "CONTINUE_SCENE":
      let currentScene = state.getIn(["scenes", action.index]);
      if(!currentScene){
        let workspaceChildren = {}, workspaceItems = {}, workspaceCameras = {};
        var workspaceBG = state.getIn(["scenes", action.index, "workspaceBG"]).toJS();
        
        if(workspaceBG.type === "VIDEO" && workspaceBG.exitEnd === duration){
          workspaceBG.enterStart = 0;
          var videoStart = workspaceBG.videoEnd;
          var videoEnd = videoStart + 10;
          if(videoEnd > workspaceBG.duration)
            videoEnd = workspaceBG.duration;
          
          workspaceBG.videoStart = videoStart;
          workspaceBG.videoEnd = videoEnd;

          workspaceBG.exitEnd = videoEnd - videoStart;
        }

        var newslide = {
          "duration": 10,
          "workspaceChildren": workspaceChildren,
          "workspaceItems": workspaceItems,
          "workspaceCameras": workspaceCameras,
          "workspaceBG": workspaceBG,
          "continuedFrom" : action.index,
          "playHeadValue": 0,
          "transEffect": "NoTransition"
        }
      state = state.setIn(["scenes", action.index, "isContinuous"], true);
      state = state.update("scenes", list => list.splice(action.index + 1, 0, fromJS(newslide)));
      state = sceneDurationReset(state);
    }else{
      state = state.setIn(["scenes", action.index, "isContinuous"], false);
    }
    
    return state;

    break;
   
      case "CHANGE_VIDEO_VOLUME_COMPLETE" :
        state  = state.setIn(["scenes",  action.selectedScene, "workspaceBG", "volume"],action.objectId)
      return state;

      case "UPDATE_BG_COMPLETE" :
        state  = state.setIn(["scenes",  action.selectedScene, "workspaceBG"], state.getIn(["scenes",  action.selectedScene, "workspaceBG"]).merge(fromJS(action.toUpdate)));
      return state;

      case 'UPLOAD_BULK_UPDATE_COMPLETE':
        for(let i=0; i<action.data.length; i++){
          if(['workspaceItems', 'workspaceChildren'].indexOf(action.data[i].type) !== -1){
            state = state.setIn(['scenes', action.data[i].selectedScene, action.data[i].type, action.data[i].id], state.getIn(['scenes', action.data[i].selectedScene, action.data[i].type, action.data[i].id]).merge(action.data[i].toUpdate));
          }else if(action.data[i].type === 'workspaceBG'){
            state = state.setIn(['scenes', action.data[i].selectedScene, action.data[i].type], state.getIn(['scenes', action.data[i].selectedScene, action.data[i].type]).merge(action.data[i].toUpdate));
          }
        }
      return state;

      case 'UPLOAD_BULK_DELETE_COMPLETE':
        for(let i=0; i<action.data.length; i++){
          if(['workspaceItems', 'workspaceChildren'].indexOf(action.data[i].type) !== -1){
            state = state.setIn(['scenes', action.data[i].selectedScene, action.data[i].type], value => value.delete(action.data[i].id));
            state = state.setIn(['scenes', action.data[i].selectedScene, action.data[i].type, action.data[i].id], fromJS(state.getIn(['scenes', action.data[i].selectedScene, action.data[i].type])))
          }else if(action.data[i].type === 'workspaceBG'){
            state = state.setIn(['scenes', action.data[i].selectedScene, action.data[i].type], state.getIn(['scenes', action.data[i].selectedScene, action.data[i].type]).merge(action.data[i].toUpdate));
          }
        }
      return state;

      case "UPDATE_PROJECT_COMPLETE" :
        for(var dKey in action.toUpdate){
          state = state.set(dKey, (Array.isArray(action.toUpdate[dKey]) || typeof action.toUpdate[dKey] === "object")?fromJS(action.toUpdate[dKey]):action.toUpdate[dKey]);
        }
        if(action.toUpdate["scenes"] !== undefined)
          state = sceneDurationReset(state);
      return state;

      case "UPDATE_SCENE_COMPLETE" :
        for(var dKey in action.toUpdate){
          state = state.setIn(["scenes", action.selectedScene, dKey], (dKey === "transColor" || dKey === "sizes" || Array.isArray(action.toUpdate[dKey]) || typeof action.toUpdate[dKey] === "object")?fromJS(action.toUpdate[dKey]):action.toUpdate[dKey]);
        }
        
        if(action.toUpdate["duration"] !== undefined)
          state = sceneDurationReset(state);
        if(action.toUpdate["workspaceItems"] !== undefined)
          state = state.setIn(["scenes", action.selectedScene, "workspaceItems"], state.getIn(["scenes", action.selectedScene, "workspaceItems"]).sortBy(function (value, key) {return value.get("index");}).toOrderedMap());
      return state;
      
      case "UPLOAD_FAILED" :
        state = state.setIn(["scenes", 0, "workspaceBG", "isBlob"], false);
      return state;

      case "SET_PLAY_ALL" :
        var assetArr = []
        if(action.data)
        {
          state.get("scenes").entrySeq().forEach(([i, sceneVal]) => {
            sceneVal.get("workspaceItems").entrySeq().forEach(([key, wsItem]) => {
              if (wsItem.get("type") !== "TEXT" && wsItem.get("type") !== "STOCKIMG" && wsItem.get("type") !== "GROUP" && wsItem.get("type") !== "UPLOADS" && wsItem.get("type") !== "IMG")
                assetArr.push(key)
            });
            sceneVal.get("workspaceChildren").entrySeq().forEach(([key, wsItem]) => {
              if (wsItem.get("type") !== "TEXT" && wsItem.get("type") !== "STOCKIMG" && wsItem.get("type") !== "UPLOADS" && wsItem.get("type") !== "IMG")
                assetArr.push(key)
            });

            if(sceneVal.get("transEffect").includes("tr-") && i !== state.get("scenes").length-1)
            assetArr.push("scenetransition" + i)
            
          });
          
          window.totalArr = assetArr
          
        }
        
      return state;

      case "SET_PLAY" :
        var assetArr = []
        if(action.data)
        {

            var sceneVal = state.getIn(["scenes", action.selectedScene]);
            

            sceneVal.get("workspaceItems").entrySeq().forEach(([key, wsItem]) => {
              if (wsItem.get("type") !== "TEXT" && wsItem.get("type") !== "STOCKIMG" && wsItem.get("type") !== "GROUP" && wsItem.get("type") !== "UPLOADS" && wsItem.get("type") !== "IMG")
                assetArr.push(key)
            });
            sceneVal.get("workspaceChildren").entrySeq().forEach(([key, wsItem]) => {
              if (wsItem.get("type") !== "TEXT" && wsItem.get("type") !== "STOCKIMG" && wsItem.get("type") !== "UPLOADS" && wsItem.get("type") !== "IMG")
                assetArr.push(key)
            });

          window.totalArr = assetArr
          
        }
        
      return state;

      case 'APPLY_ALL_TRANSITION_COMPLETE':

        const {isUndo , sceneTransData , transData} = action;
        if(isUndo && sceneTransData){
          for(let i=0;i<sceneTransData.length;i++){
           state = state.setIn(['scenes', i, 'transEffect'], sceneTransData[i].toUpdate.transEffect);
           state = state.setIn(['scenes', i, 'sizes'], sceneTransData[i].toUpdate.sizes);
           state = state.setIn(['scenes', i, 'transColor'], sceneTransData[i].toUpdate.transColor);
           }
         }
       else{
          for(var i=0;i<state.get('scenes').size-1;i++){
             for(var dKey in transData){
            state = state.setIn(['scenes', i, dKey], transData[dKey])
            }
          }
       }
        return state;

      case 'ADD_LINK_TO_TEXT_COMPLETE':
       
       if(action.hyperLinkData)
       {
        var selectedText = state.getIn(["scenes", action.selectedScene, action.container, action.selectedItem, "textData"]);
        if(selectedText !== undefined){
          selectedText = selectedText.set('link',action.hyperLinkData.link);
        }
       
        
        
        state = state.setIn(["scenes", action.selectedScene, action.container, action.selectedItem, "textData"], selectedText);         
       }
        return state;

      case 'SET_WORKSPACE_ITEMS_ORDER_COMPLETE':
        const itemsOrder =action.workspaceItemsOrder;
        for(let key in itemsOrder){
          state = state.setIn(['scenes',action.selectedScene,action.container,key,'animIndex'],itemsOrder[key]);
        }

      return state;
    
      case 'SET_ANIMATE_VALUE_COMPLETE':
        state = state.setIn(['scenes',action.selectedScene,action.container,action.selectedItem,'animType'],action.animateData);
      return state;
    
      case 'ADD_LINK_TO_OBJ_COMPLETE':
         state = state.updateIn(["scenes",action.selectedScene,"workspaceItems",action.selectedItem,'link'],value=>action.linkData.link);  
        
      return state;

    default:
      return state
  }
}

export default animakerStore


// WEBPACK FOOTER //
// ./src/reducers/project.js